import React from "react";
import { useField } from "formik";

const MyInputField = ({ label, required, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <React.Fragment>
      <label htmlFor={props.id || props.name}>
        {label} {required ? <sup>*</sup> : null}
      </label>
      <input
        {...field}
        {...props}
        className={meta.touched && meta.error ? "hasError" : null}
      />
      {meta.touched && meta.error && (
        <p className="errorMessage">{meta.error}</p>
      )}
    </React.Fragment>
  );
};

export default MyInputField;
